import $ from 'jquery';
import _ from 'lodash';
import ParsleyJS from 'parsleyjs';

/**
 * An object of CONFIG used in this view
 * @property CONFIG
 * @type {Object}
 * @final
 */
const DEFAULTS = {
    errorClass: 'error',
    focus: 'first',
    errorsWrapper: '<ul class="formError"></ul>',
    errorTemplate: '<li></li>',
};
/*ERROR_CLASS: 'error',
 SUCCESS_CLASS: 'valid',
 ERROR_WRAPPER_CLASS: 'formError',
 SUCCESS_WRAPPER_CLASS: 'formValid',
 EMPTY_WRAPPER_CLASS: 'formMessageEmpty',
 SUCCESS_MESSAGE: 'Success',
 ERROR_MESSAGE: 'This field is required',
 NOT_EQUAL_MESSAGE: 'Passwords to not match',
 MESSAGE_WRAPPER: '<ul></ul>',
 MIN_CHARS_TO_VALIDATE: 3,
 VALIDATE_DELAY: 350,
 VALIDATE_URL: `https://secure-srtr.nerderylabs.com${DATA_CONFIG.PASSWORD_VALIDATION_PATH}`,*/


/**
 * Form Validation
 *
 * @class FormValidation
 * @param {jQuery} Pass in containing dom element
 * @constructor
 */
export default class FormValidation {
    /**
     * Form validation view
     *
     * @class Form Validation
     * @param {jQuery} $form
     * @constructor
     */
    constructor($form) {
        if (!$form) {
            throw ('No FormValidation $form passed into function');
        }
        /**
         * A reference to the containing DOM element
         *
         * @property $form
         * @type {jQuery}
         * @public
         */
        this.$form = $form;

        /**
         * Tracks whether view is enabled
         *
         * @default false
         * @property mapsLoaded
         * @type {Boolean}
         * @public
         */
        this.isEnabled = false;
        // If no form is found, return early
        if (!this.$form.length) {
            return;
        }
        // If form already has novalidate attribute
        if (this.$form.attr('novalidate') !== undefined) {
            return;
        }
        this.init();
    }
    /**
     * @method init
     * @public
     * @chainable
     */
    init() {
        this.isEnabled = false;

        return this.setupHandlers()
            .createChildren()
            .layout()
            .enable();
    }
    /**
     * @method createChildren
     * @public
     * @chainable
     */
    createChildren() {
        this.formValidator = this.$form.parsley(DEFAULTS);

        return this;
    }
    /**
     * Binds the scope of handler functions
     * Should be run once on view initialization
     *
     * @method setupHandlers
     */
    setupHandlers() {
        return this;
    }
    /**
     * Update the DOM to reflect the current state of the model
     *
     * @method layout
     * @returns {FormValidation}
     */
    layout() {
        return this;
    }

    /**
     * Disable, update the DOM, and then re-enable to create handlers for new DOM
     *
     * @method render
     */
    render() {
        this.disable();
        this.layout();
        this.enable();
    }

    /**
     * Enables the view
     * Performs binding to handlers
     * Exits early if already enabled
     *
     * @method enable
     * @returns {FormValidation}
     */
    enable() {
        if (this.isEnabled) {
            return this;
        }

        this.isEnabled = true;

        _.forEach(this.$submit, (value, key) => {
            this.$submit[key].addEventListener('submit', this.handleSubmit);
        });
        return this;
    }

    /**
     * Disables the view
     * Tears down any event binding to handlers
     * Exits early if it is already disabled
     *
     * @method disable
     * @returns {FormValidation}
     */
    disable() {
        if (!this.isEnabled) {
            return this;
        }

        _.forEach(this.$submit, (value, key) => {
            this.$submit[key].removeEventListener('submit', this.handleSubmit);
        });

        this.isEnabled = false;

        return this;
    }

    /**
     * Destroys the view
     * Tears down any events, handlers, elements
     * Should be called when the object should be left unused
     *
     * @method destroy
     * @returns {FormValidation}
     */
    destroy() {
        this.disable();

        return this;
    }

    /**
     * @method revalidate
     * @public
     * @param {string} [imageUpload] the group you want to revalidate
     * @chainable
     */
    revalidate(group) {
        this.formValidator.validate(group);
        return this;
    }

    /**
     * @method displayCustomError
     * @public
     * @param {Object} [options] an options object of the display custom error
     * @param {jQuery} [options.$input] the jquery input that we need to display the message on
     * @param {String} [options.errorMessage] the error message string to display
     * @chainable
     */
    displayCustomError(options) {
        const parsleyInstance = this.getParsleyFieldInstance(options.$input);
        if (!parsleyInstance) {
            return this;
        }
        window.ParsleyUI.addError(parsleyInstance, 'field-error', options.errorMessage);
        return this;
    }

    /**
     * @method removeCustomError
     * @public
     * @param {Object} [options] an options object of the display custom error
     * @param {jQuery} [options.$input] the jquery input that we need to display the message on
     * @chainable
     */
    removeCustomError(options) {
        const parsleyInstance = this.getParsleyFieldInstance(options.$input);
        if (!parsleyInstance) {
            return this;
        }
        window.ParsleyUI.removeError(parsleyInstance, 'field-error');
        return this;
    }

    /**
     * @method getParsleyFieldInstance
     * @public
     * @param {jQuery} [$input]
     */
    getParsleyFieldInstance($input) {
        let parsleyFieldInstance = null;
        const parsleyFieldId = $input.data('parsleyId');
        const length = this.formValidator.fields.length;
        let id = null;
        for (let i = 0; i < length; i++) {
            id = parseInt(this.formValidator.fields[i].__id__);
            if (id === parsleyFieldId) {
                parsleyFieldInstance = this.formValidator.fields[i];
                console.log(parsleyFieldInstance);
                break;
            }
        }
        return parsleyFieldInstance;
    }
}
